// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

var Types = {};

var fragmentConverter = {};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

var Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

function localDraftGeocodingStatus_decode($$enum) {
  if ($$enum === "ErrorDuplicateListing" || $$enum === "Error" || $$enum === "Valid" || $$enum === "Called" || $$enum === "NotCalled" || $$enum === "ErrorOutsideChapterBoundaries") {
    return $$enum;
  }
  
}

function localDraftGeocodingStatus_fromString(str) {
  return localDraftGeocodingStatus_decode(str);
}

var Utils = {
  localDraftGeocodingStatus_decode: localDraftGeocodingStatus_decode,
  localDraftGeocodingStatus_fromString: localDraftGeocodingStatus_fromString
};

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PropertyWizardFormRelayValidatorsDescriptionDisplayNeighborhood_formState",
  "selections": [
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LocalDraftDisplayNeighborhood",
          "kind": "LinkedField",
          "name": "displayNeighborhoods",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "id",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "geocodingStatus",
          "storageKey": null
        }
      ]
    }
  ],
  "type": "LocalDraftFormState",
  "abstractKey": null
};

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
